if (!customElements.get('search-drawer')) {
  customElements.define(
    'search-drawer',
    class SearchDrawer extends DrawerElement {
      constructor() {
        super();
      }

      get shouldAppendToBody() {
        return false;
      }

      get input() {
        return this.querySelector('input[type="search"]');
      }

      get focusElement() {
        return this.querySelector('input[type="search"]');
      }

      show(activeElement = null, animate = true) {
        // KICA: open the on-screen keyboard on iOS Safari by focusing the search
        // input synchronously inside the click handler chain. Two blockers had
        // to be lifted first:
        //   1. <search-drawer hidden> applies display:none + content-visibility:
        //      hidden via theme.css [hidden] rules. super.show() flips that
        //      synchronously via attributeChangedCallback (sets this.hidden = false
        //      when [open] is added), so we call it first.
        //   2. .drawer__content keeps `.invisible .opacity-0` (visibility:hidden)
        //      until DrawerElement.showTransition() sets [active] ~75ms later.
        //      We promote visibility synchronously via inline style so iOS sees
        //      the input as visible at focus() time. The transition's later
        //      [active] add still works (CSS still applies its opacity/visibility
        //      transition properties on top), and we clear the inline styles
        //      after a beat so hide animation runs normally.
        const result = super.show(activeElement, animate);

        const content = this.querySelector('.drawer__content');
        if (content) {
          content.style.visibility = 'visible';
          content.style.opacity = '1';
        }
        try { this.input?.focus({ preventScroll: true }); } catch (e) { /* ignore */ }

        if (content) {
          setTimeout(() => {
            content.style.visibility = '';
            content.style.opacity = '';
          }, 500);
        }

        return result;
      }
    }
  );
}

// --- ОСЬ ЦЕЙ БЛОК МИ ЗМІНИЛИ ---
if (!customElements.get('search-typed')) {
  customElements.define(
    'search-typed',
    class SearchTyped extends HTMLElement {
      constructor() {
        super();
        
        // НАЛАШТУВАННЯ: Список слів для анімації
        this.phrases = [
          "Macarons", 
          "Croissants", 
          "Cheesecake", 
          "Kyiv Cake", 
          "Chocolate",
          "Search..." // Можна залишити слово Search в кінці
        ];

        Motion.inView(this, this.init.bind(this));
      }

      async init() {
        this.insertCursor();
        // Запускаємо безкінечний цикл з першого слова (індекс 0)
        await this.typeLoop(0);
      }

      async typeLoop(index) {
        // Захист: якщо елемент зник зі сторінки, зупиняємо цикл
        if (!this.isConnected) return;

        // Вибираємо слово по колу using modulo operator %
        const currentPhrase = this.phrases[index % this.phrases.length];

        // 1. ДРУКУЄМО (З'являється)
        this.innerHTML = currentPhrase;
        // Отримуємо ширину тексту, щоб знати до скількох розширювати
        const fullWidth = this.scrollWidth;
        
        // Анімація від 0 до повної ширини
        await Motion.animate(this, { width: [0, `${fullWidth}px`] }, { duration: 1 }).finished;
        this.cursor.classList.add('blink');

        // 2. ЧЕКАЄМО (Поки користувач прочитає)
        await new Promise(resolve => setTimeout(resolve, 2000));

        // 3. СТИРАЄМО (Зникає)
        this.cursor.classList.remove('blink');
        await Motion.animate(this, { width: 0 }, { duration: 0.5 }).finished;

        // 4. КОРОТКА ПАУЗА перед новим словом
        await new Promise(resolve => setTimeout(resolve, 300));

        // 5. РЕКУРСІЯ: Запускаємо функцію знову для наступного слова
        this.typeLoop(index + 1);
      }

      insertCursor() {
        if (this.cursor) return;

        this.cursor = document.createElement('span');
        this.cursor.className = 'typed-cursor';
        this.cursor.setAttribute('aria-hidden', true);
        this.cursor.innerHTML = '|';
        this.parentElement.insertBefore(this.cursor, this.nextSibling);
      }
    }
  );
}
// -------------------------------

if (!customElements.get('predictive-search')) {
  customElements.define(
    'predictive-search',
    class PredictiveSearch extends HTMLFormElement {
      constructor() {
        super();

        this.cachedMap = new Map();
        this.focusElement = this.input;

        this.resetButton.addEventListener('click', this.clear.bind(this));
        this.input.addEventListener('click', this.hideTypewriter.bind(this));
        this.input.addEventListener('input', theme.utils.debounce(this.onChange.bind(this), 300));
        this.input.addEventListener('focus', this.onFocus.bind(this));
      }

      get input() {
        return this.querySelector('input[type="search"]');
      }

      get resetButton() {
        return this.querySelector('button[type="reset"]');
      }

      get typewriter() {
        return this.input.previousElementSibling;
      }

      hideTypewriter() {
        if (this.typewriter && !this.typewriter.hasAttribute('hidden')) {
          this.typewriter.setAttribute('hidden', '');
        }
      }

      onFocus(event) {
        if (this.closest('.collection')) {
          document.body.classList.add('predictive-search-open');

          const searchTerm = this.getQuery();
          if (searchTerm.length === 0) return;

          const url = this.buildUrl().toString();
          this.renderSection(url, event);
        }
      }

      clear(event = null) {
        if (event) event.preventDefault();

        this.input.value = '';
        this.input.focus();
        this.removeAttribute('results');
      }

      getQuery() {
        return this.input.value.trim();
      }

      buildUrl() {
        const url = new URL(`${theme.routes.shop_url}${theme.routes.predictive_search_url}`);

        url.searchParams.set('q', this.getQuery());
        url.searchParams.set('resources[limit]', this.hasAttribute('data-limit') ? parseInt(this.getAttribute('data-limit')) : 3);
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('section_id', theme.utils.sectionId(this));
        return url;
      }

      onChange() {
        if (this.getQuery().length === 0) {
          this.clear();
          return;
        }

        this.hideTypewriter();

        const url = this.buildUrl().toString();
        this.renderSection(url);
      }

      renderSection(url) {
        this.cachedMap.has(url)
          ? this.renderSectionFromCache(url)
          : this.renderSectionFromFetch(url);
      }

      renderSectionFromCache(url) {
        const responseText = this.cachedMap.get(url);
        this.renderSearchResults(responseText);

        this.setAttribute('results', '');
      }

      renderSectionFromFetch(url) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        
        this.setAttribute('loading', '');

        fetch(url, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.renderSearchResults(responseText);
            this.cachedMap.set(url, responseText);

            this.removeAttribute('loading');
            this.setAttribute('results', '');
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            }
            else {
              console.error(error);
            }
          });
      }

      renderSearchResults(responseText) {
        const id = 'PredictiveSearchResults-' + theme.utils.sectionId(this);
        if (document.getElementById(id) === null) return;

        document.getElementById(id).innerHTML = new DOMParser()
          .parseFromString(responseText, 'text/html')
          .getElementById(id).innerHTML;
      }
    }, { extends: 'form' }
  );
}

if (!customElements.get('predictive-search-overlay')) {
  customElements.define(
    'predictive-search-overlay',
    class PredictiveSearchOverlay extends OverlayElement {
      constructor() {
        super();

        this.addEventListener('click', this.onClick);
      }

      onClick() {
        setTimeout(() => {
          document.body.classList.remove('predictive-search-open');
        });
      }
    }
  );
}